import * as http from 'utils/http';
import config from 'config';

const getDriverDocuments = async (driverId) =>
  await http.get(`${config.BASE_URL}/api/dms/documents/driver/${driverId}/`);

export { getDriverDocuments };
